import type { Address, InputFormData, PropertyType } from './inputForm';

export type PredictParams = {
    size: string;
    address: Address;
    propertyType: PropertyType;
    floor?: string;
    bedrooms?: string;
    userId: number;
    consentPersonalisation: boolean;
    sampleSize: string;
    selectedAdIds: number[];
    initialPrediction?: boolean;
};

export function createParamsFromInputFormData(inputFormData: InputFormData): PredictParams {
    if (!inputFormData.size || !inputFormData.address || !inputFormData.propertyType) {
        throw new Error('Missing required fields in InputFormData');
    }

    return {
        size: inputFormData.size,
        address: inputFormData.address,
        propertyType: inputFormData.propertyType,
        floor: inputFormData.floor,
        bedrooms: inputFormData.bedrooms,
        userId: 0,
        consentPersonalisation: false,
        sampleSize: '6',
        selectedAdIds: [],
    };
}

export function toQueryString(params: PredictParams): string {
    const queryParams = new URLSearchParams();

    const addParam = (key: string, value: unknown) => {
        if (value !== undefined && value !== null) {
            queryParams.append(key, String(value));
        }
    };

    addParam('size', params.size);
    addParam('propertyType', params.propertyType);
    addParam('floor', params.floor);
    addParam('bedrooms', params.bedrooms);

    for (const [key, value] of Object.entries(params.address)) {
        addParam(`address.${key}`, value);
    }

    for (const selectedAdId of params.selectedAdIds) {
        addParam('selected', selectedAdId);
    }

    if (params.initialPrediction === true) {
        addParam('initialPrediction', 'true');
    }

    return queryParams.toString();
}
